import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles({
  BtnOnPopper: {
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: "300px",
      background: theme.color.white,
      color: theme.color.black,
      "&:hover": {
        background: "#d5d5d5",
      },
    },
  },
});

export default useStyles;
